// extracted by mini-css-extract-plugin
export default {"otzyvyMainTitle":"otzyvy_otzyvyMainTitle__fg+Ft"};